import { Typography } from 'antd';

const { Text } = Typography;

type ProductTitleEllipsisProps = {
  title?: string | null;
};

export function ProductTitleEllipsis({ title }: ProductTitleEllipsisProps) {
  const text = title?.trim();
  if (!text) return null;

  return (
    <Text ellipsis={{ tooltip: text }} style={{ display: 'block', width: '100%' }}>
      {text}
    </Text>
  );
}
